<div class="header-row">
    <form [formGroup]="searchForm" (ngSubmit)="filterItems()">
        <input
            hamInput
            icon="/assets/hamIcons/search-outline.svg"
            formControlName="searchTerm"
            placeholder="{{ 'aumico_search_placeholder' | i18next }}"
            (cancel)="resetFilter()"
        />
    </form>
    <ham-button icon="assets/hamIcons/plus-outline.svg" (click)="addNewUser()">
        {{ 'aumico_reports_organization_settings_users_add_new_button' | i18next }}
    </ham-button>
</div>
<div #pageWrapper>
    <ham-table-with-actions
        [dataSource]="filteredData"
        [pageSize]="10"
        [menuItems]="menuItems"
        [clearSelections]="clearSelectionsFlag"
        (menuOptionClicked)="onMenuItemClicked($event)"
        (checkBoxSelectionChanged)="onCheckBoxSelectionChanged($event)"
        [pagination]="false"
    >
        <ng-template hamHeaderCell hamTextCol>
            {{ 'aumico_users_organization_users_table_name_label' | i18next }}
        </ng-template>
        <ng-template hamHeaderCell hamTextCol>
            {{ 'aumico_users_organization_users_table_email_label' | i18next }}
        </ng-template>
        <ng-template hamHeaderCell hamTextCol>
            {{ 'aumico_users_organization_users_table_role_label' | i18next }}
        </ng-template>

        <ng-template hamHeaderCell hamTextCol>
            {{ 'aumico_users_organization_users_table_date_added_label' | i18next }}
        </ng-template>
        <ng-template hamHeaderCell hamTextCol>
            {{ 'aumico_users_organization_users_table_status_label' | i18next }}
        </ng-template>
        <ng-template hamCell let-element hamTextCol>
            <ng-container *ngIf="!element.isInvitee">
                <ham-avatar type="circle" size="regular" [displayName]="true" [fullName]="element?.name"></ham-avatar>
            </ng-container>
        </ng-template>
        <ng-template hamCell let-element hamTextCol> {{ element?.email || '-' }} </ng-template>
        <ng-template hamCell let-element hamTextCol>
            <ng-container *ngIf="!element.isInvitee">
                <div class="dropdown-wrapper role">
                    <ham-button
                        #roleButtonWrapper
                        class="role-button"
                        size="xs"
                        variant="white"
                        [disabled]="element.isMe"
                        (buttonClick)="openRoleFlyout(element.id, roleButtonWrapper)"
                        (click)="$event.stopPropagation()"
                    >
                        <span class="inner-role-wrapper">
                            <span class="role-display"
                                >{{ organizationUserRolesLabels[element.organizationRole] }}</span
                            >
                            <span>
                                <span class="ham-icon">
                                    <i class="chevron-down-icon"></i>
                                </span>
                            </span>
                        </span>
                    </ham-button>
                </div>

                <span
                    class="menu-flyout"
                    hamFlyout
                    *ngIf="openedRoleFlyoutUserId === element.id"
                    [position]="flyoutPosition"
                    (closeFlyout)="closeRoleFlyout()"
                >
                    <div class="flyout-role-options-content">
                        <div
                            *ngFor="let role of organizationUserRoles"
                            class="status-option role"
                            [class.selected]="element.organizationRole === role"
                            (click)="confirmRoleChange(element, role); $event.stopPropagation()"
                        >
                            <span class="name">{{ organizationUserRolesLabels[role] }}</span>
                        </div>
                    </div>
                </span>
            </ng-container>
        </ng-template>
        <ng-template hamCell let-element hamTextCol>
            {{ element.createdAt ? (element.createdAt | dateLocale) : '-' }}
        </ng-template>
        <ng-template hamCell let-element>
            <div class="d-flex align-items-center gap-2" *ngIf="element.isInvitee; else user">
                <span hamBadge color="yellow" icon="assets/hamIcons/clock-outline.svg"
                    >{{ 'aumico_users_organization_users_table_pending_label' | i18next }}</span
                >
                <span class="resend-invite-link" (click)="onResendInvite(element.id)">
                    {{'aumico_users_organization_users_table_resend_invite'| i18next}}</span
                >
            </div>
            <ng-template #user>
                <span hamBadge color="green" icon="assets/hamIcons/check-circle-outline.svg"
                    >{{ 'aumico_users_organization_users_table_active_label' | i18next }}</span
                >
            </ng-template>
        </ng-template>
        <ng-template hamMenuButton let-element>
            <span
                hamIconShapes
                [variant]="'transparent'"
                size="regular"
                icon="assets/hamIcons/x-circle.svg"
                color="gray"
                (click)="onShowWithdrawModal(element.id)"
                *ngIf="element.isInvitee"
            >
            </span>
            <span
                hamIconShapes
                [variant]="'transparent'"
                size="regular"
                icon="assets/hamIcons/trash-outline.svg"
                color="gray"
                *ngIf="!element.isInvitee"
                (click)="onShowDeleteModal(element.id)"
            >
            </span>
        </ng-template>
    </ham-table-with-actions>
</div>
<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showWithdrawModal"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_users_organization_users_table_withdraw_invite_action' | i18next }}"
    noActionBtnText="{{ 'aumico_annual_report_cancel_button' | i18next }}"
    (cancel)="onCancelWithdraw()"
    (action)="withdrawInvite()"
>
    <withdraw-invitation></withdraw-invitation>
</ham-confirm-decline-modal>

<ham-confirm-decline-modal
    *ngIf="showResendInviteModal"
    footerAlignment="center"
    btnVariant="primary"
    actionBtnText="{{ 'aumico_users_organization_users_table_resend_invite_action' | i18next }}"
    noActionBtnText="{{ 'aumico_annual_report_cancel_button' | i18next }}"
    (cancel)="showResendInviteModal = false"
    (action)="resendInvite()"
>
    <resend-invitation> </resend-invitation>
</ham-confirm-decline-modal>

<ham-confirm-decline-modal
    class="confirm-decline-modal"
    *ngIf="showDeletionUserModal"
    footerAlignment="center"
    [actionBtnText]=" 'aumico_reports_organization_delete' | i18next "
    [noActionBtnText]="'aumico_annual_report_cancel_button' | i18next "
    (cancel)="onCancelDeletion()"
    (action)="deleteUser()"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_reports_organization_delete_user' | i18next"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
<bulk-edit-action-bar
    *ngIf="selectedRows?.length > 0"
    [selectedCount]="selectedRows?.length"
    [actions]="bulkActions"
    [deleteAction]="deleteAction"
    textSelectedTranslationKey="aumico_companies_bulk_edit_action_bar_selected_text"
    [globalPosition]="true"
    (actionClicked)="onActionClicked($event)"
></bulk-edit-action-bar>

<!-- Ham Modal for Role Change -->
<ham-modal
    *ngIf="openBulkEditRole"
    [title]="'aumico_company_role_change_dialog_title' | i18next : { count: selectedRows.length }"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    (cancel)="openBulkEditRole = false; this.bulkEditRoleControl.reset()"
    [saveText]="'aumico_button_save' | i18next"
    (save)="onEditRoleConfirm()"
    ><input
        hamSimpleDropDown
        [label]="'aumico_company_role_change_dialog_select_new_role' | i18next"
        [options]="roleDropdownOptions"
        [optionKeys]="['label']"
        returnKey="id"
        [returnObject]="false"
        [placeholder]="'aumico_company_role_change_dialog_add_role_for_selected_tasks' | i18next"
        [formControl]="bulkEditRoleControl"
/></ham-modal>
